import React, { InputHTMLAttributes, AreaHTMLAttributes } from 'react'
import { css } from '@emotion/react'

import Colors from '../theme/Colors'
import FormError from './FormError'
import FormLabel from './FormLabel'
import Spacer from './Spacer'

export default function FormInput(
  props: (AreaHTMLAttributes<HTMLTextAreaElement> | InputHTMLAttributes<HTMLInputElement>) & {
    label?: React.ReactNode
    error?: string
    touched?: boolean
    multiline?: boolean
  },
) {
  const { touched, error, multiline, label, ...rest } = props
  const fieldCss = css`
    width: 100%;
    border: solid 1px ${error && touched ? Colors.Red400 : Colors.Gray100};
    border-radius: 2px;
    padding: 12px 10px;
    box-sizing: border-box;
    color: ${Colors.Gray600};
    outline: none;

    ::placeholder {
      color: ${Colors.Gray300};
    }

    :focus {
      border-color: ${Colors.Teal400};
    }

    :disabled {
      background: ${Colors.Gray50};
      color: ${Colors.Gray300};
    }
  `
  return (
    <Spacer direction="vertical" gap={5}>
      {label && <FormLabel>{label}</FormLabel>}

      {multiline ? (
        <textarea rows={3} css={fieldCss} {...(rest as AreaHTMLAttributes<HTMLTextAreaElement>)} />
      ) : (
        <input css={fieldCss} {...(rest as InputHTMLAttributes<HTMLInputElement>)} />
      )}

      {error && touched && <FormError error={error} />}
    </Spacer>
  )
}
